import { render } from "./SeeReview.vue?vue&type=template&id=3a93d458"
import script from "./SeeReview.vue?vue&type=script&lang=js"
export * from "./SeeReview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__